import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { Modal } from "reactstrap";
import { createNotification } from "../../Common/CreateNotification";
import { useDispatch } from "react-redux";
import { toggleLoading } from "../../../Redux/reducers/loadingSlice";
import { baseUrl } from "../../../shared/baseUrl";
import { TOKEN_KEY } from "../../../Utils/Constants";
import getUsersCities from '../../../Hooks/getUsersCities';
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import { changeUser } from "../../../Redux/reducers/userSlice";

const EditProfile = ({ isOpen, onClose, user }) => {

    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [contact, setContact] = useState('');
    const [city, setCity] = useState('');
    const [cityOption, setCityOption] = useState('');

    const reset = () => {
        setName('');
        setContact('');
        setCity('');
    }


    useEffect(() => {
        const setCities = async () => {
            const userCities = await getUsersCities();
            setCityOption(userCities);
            setName(user.name);
            setContact(user.contact);
            setCity(userCities.find((city) => city.label === user.city).value);
        }
        setCities()

    }, [user])

    const animatedComponents = makeAnimated();

    const handleChangePassword = async (e) => {
        e.preventDefault();
        dispatch(toggleLoading(true));

        await fetch(baseUrl + 'edit-my-details', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
            },
            body: JSON.stringify({
                name: name,
                contact: contact,
                city: city,
            }),
        })
            .then(response => response.json())
            .then(res => {
                if (res.success) {
                    localStorage.setItem(TOKEN_KEY, JSON.stringify(res.data));
                    createNotification('success', res.message);
                    dispatch(changeUser(res.data));
                    reset();
                    onClose();
                    dispatch(toggleLoading(false));
                } else {
                    createNotification('error', res.message);
                    dispatch(toggleLoading(false));
                }
            })
            .catch(e => {
                createNotification('error', 'Failed to update user details!');
                dispatch(toggleLoading(false));
            });

    }

    return (
        <Modal isOpen={isOpen} className='position-relative' centered>
            <div onClick={onClose} className='position-absolute cursor-pointer' style={{ zIndex: 10, top: 6, right: 10 }}>
                <FaTimes size={20} />
            </div>
            <div className='p-3 sc-modal-content'>
                <h4 className='text-left pb-3'>Edit Profile</h4>
                <form onSubmit={handleChangePassword} className='g-3 mt-3' autoComplete="off">
                    <div className="col-12 mb-3">
                        <label className="form-label fw-bold">Full Name</label>
                        <input type="text" className="form-control" placeholder='Full Name' autoComplete='false' value={name} onChange={(e) => { setName(e.target.value); }} />
                    </div>
                    <div className="col-12 mb-3">
                        <label className="form-label fw-bold">City</label>
                        {cityOption && <Select
                            // ref={selectBrandRef}
                            autoComplete={false}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            placeholder={'Select City'}
                            isMulti={false}
                            options={cityOption}
                            value={cityOption.find((u) => u.value === city)} // set selected values
                            onChange={(e) => {
                                if (e !== null) {
                                    setCity(e.value);
                                }
                            }}

                        />
                        }
                    </div>
                    <div className="col-12 mb-3">
                        <label className="form-label fw-bold">Phone Number</label>
                        <input type="text" className="form-control" placeholder="Phone Number" value={contact} onChange={(e) => { setContact(e.target.value) }} />
                    </div>
                    <div className="col-12 d-flex justify-content-start">
                        <button type="submit" className="btn btn-primary">Done</button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}

export default EditProfile;